<template>
  <div>
    <Quill v-model="content" :readOnly="true" />
    <Reader :content="content" />
  </div>
</template>

<script>
import Quill from '@/components/Quill/Quill.vue';
import Reader from '@/components/Quill/Reader.vue';

export default {
  name: 'EditorView',
  components: {
    Quill,
    Reader,
  },
  watch: {
    content() {
      console.log(JSON.stringify(this.content));
    },
  },
  data() {
    return {
      content: '',
    };
  },
  methods: {
    update(content) {
      this.content = content;
    },
  },
};
</script>

<style lang="scss"></style>
